import Sortable from 'sortablejs/Sortable';

import { compare } from '../helpers/arrays';

function activateSortable(el) {
  const els = document.querySelectorAll(el);

  for (const el of els) {
    let options = { animation: 150 };
    const url = el.getAttribute('data-sortable-url');

    if (url) {
      options['onStart'] = function() {
        this.startingIDs = this.toArray();
      };

      options['onEnd'] = function() {
        this.endingIDs = this.toArray();

        if (!compare(this.startingIDs, this.endingIDs)) {
          $.ajax({
            method: 'PATCH',
            url: url,
            dataType: 'json',
            data: {
              ids: JSON.stringify(this.endingIDs)
            }
          });
        }
      };
    }

    Sortable.create(el, options);
  }
}

export default activateSortable;
